var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandphoneLock = function SvgHandphoneLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.555 29.25H7.472a1.361 1.361 0 0 1-1.361-1.361V6.11A1.361 1.361 0 0 1 7.47 4.75h13.612a1.36 1.36 0 0 1 1.361 1.361v4.083",
    stroke: "#5D5BEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.236 7.472h4.083L17 4.75h-5.444l.68 2.722Z",
    stroke: "#5D5BEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.607 22.87-1.843 1.843-1.844-1.843m-4.792-1.106a6.635 6.635 0 1 1 13.27 0 6.635 6.635 0 0 1-13.27 0v0Zm6.636-2.95v5.899-5.898Z",
    stroke: "#F26722",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHandphoneLock;